import { useEffect, useState } from "react";
import { PaymentMethods } from "../../../components/billing";
import { Button } from "../../../components/button.component";
import { Card } from "../../../components/card.component";
import { ApiSchemaCardDetails } from "../../../models/api";
import { ApiBilling } from "../../../core/apis/billing";
import { StorageAuth } from "../../../core/localStorage";
import { AppRouteUi } from "../../../config/appRoute";
import { Utility } from "../../../config";

export function PagePaymentMethod() {
  const redirectURL =
    window.location.origin + AppRouteUi.Billing.PaymentMethod();
  const [data, setData] = useState<ApiSchemaCardDetails[]>([]);
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [isFetchingSessionId, setIsFetchingSessionId] = useState(false);

  const handleAddPayment = async () => {
    setIsFetchingSessionId(true);
    const response = await ApiBilling.GetStripeSessionId({
      CompanyId: StorageAuth.CompanyId!,
      SuccessUrl: redirectURL,
      CancelUrl: redirectURL,
    });
    if (response.isSuccess && response.data) {
      Utility.getStripe()?.redirectToCheckout({
        sessionId: response.data,
      });
    }
  };

  useEffect(() => {
    const getData = async () => {
      setIsTableDataLoading(true);
      const response = await ApiBilling.GetCardDetails();
      if (response.isSuccess) {
        setData([response.data!]);
      }
      setIsTableDataLoading(false);
    };

    getData();
  }, []);

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Payment Methods
              </p>
            </div>
          </div>
        </div>
      }
    >
      <div className="d-flex mt-0 mb-2">
        <Button
          name={
            data.length ? "Update Payment Method" : "Add New Payment Method"
          }
          className="me-2 btn-green"
          disabled={isTableDataLoading || isFetchingSessionId}
          onClick={handleAddPayment}
          loading={isFetchingSessionId}
        />
      </div>
      <PaymentMethods data={data} isLoading={isTableDataLoading} />
    </Card>
  );
}
